/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList, ResourceContextProvider
} from 'react-admin';
import {
    useMediaQuery, makeStyles, FormControl, Select, MenuItem, InputLabel, Paper, Typography 
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import notify from './components/CustomUseNotify';
import config from "./config.json";
import { saveTokens } from './utils/saveTokens';
import CustomDateTimePicker from './components/CustomDateTimePickerV2';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import { stringify } from 'query-string';
import Skeleton from '@material-ui/lab/Skeleton';
// import ReactApexChart from 'react-apexcharts';
import CustomSearch from './components/CustomSearch';
import LinearProgress from '@material-ui/core/LinearProgress';
import CustomFilter from './components/CustomFilter';
import ShowTimePeriod from './components/ShowTimePeriod';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    title: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 22,
        color: customTheme.palette.grey[900],
    },
    summaryBoxLabel2: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
});

const CATEGORY = "QR TRANSACTIONS SECTION"
const QR_TRANSACTIONS = "QR_TRANSACTIONS"
const QR_CODES = "QR_CODES"
const QR_LEASING = "QR LEASING";

export const QRTransactions = props => {
    const eventTracker = UseAnalyticsEvent();
    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [qrTransactionsSummary, setqrTransactionSummary] = useState({})
    const [loadingSummary, setLoadingSummary] = useState(false);
    const [currentTab, setCurrentTab] = React.useState(QR_TRANSACTIONS)
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Name"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Name");
    const finalZones = currentParking.zones_obj ? JSON.parse(currentParking.zones_obj) : [];

    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [filterListValueTransactions, setFilterListValueTransactions] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [filterListValueCodes, setFilterListValueCodes] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [filterListValueLeasing, setFilterListValueLeasing] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const [settingFilterFormatTransactions, setSettingFilterFormatTransactions] = useState({})
    const [settingFilterFormatCodes, setSettingFilterFormatCodes] = useState({})
    const [settingFilterFormatLeasing, setSettingFilterFormatLeasing] = useState({})
    const [showTiles, setShowTiles] = useState(true)
    
    let filterTypesInitState = [
        {
            resourcePath: "qrTransactionFilters",
            filterType: "QR Codes",
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "name",
            source: "name",
            showFilter: true
        },
        {
            filterType: "Portal",
            dataList: [{ name: "Razorpay", id: 1 }, { name: "Phonepe", id: 2 }, { name: "Paytm", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        }
    ]
    
    const QrTransactionFilters = {...settingFilterFormatTransactions, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined ,is_leasing: 0,};
    const filter = {...settingFilterFormatCodes, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    const QrLeasingFilters = {...settingFilterFormatLeasing, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined ,  is_leasing: 1, };
    
    const QrTransactionList = (props) => {
     return (
        <ResourceContextProvider value="qrTransactions">
            <List
                {...props}
                basePath="/qrTransactions"
                title="QR Transactions"
                bulkActionButtons={false}
                exporter={false}
                filter={QrTransactionFilters}
                empty={false}
                pagination={<CustomPagination />}
                actions={false}
                sort={{ field: 'created_at', order: 'DESC' }}
                syncWithLocation={false}
            >
                {
                    isSmallDevice ?
                        <SimpleList
                            primaryText={record => renderTime(record["created_at"])}
                            secondaryText={record => (<div>
                                {record.id && <div><span style={{ color: "#5a5a5a" }}>Txn ID: </span>{record.id}</div>}
                                {record.description && <div><span style={{ color: "#5a5a5a" }}>QR Code: </span>{record.qrcode_description}</div>}
                                {record.amount && <div><span style={{ color: "#5a5a5a" }}>Amount: </span>₹ {record.amount}</div>}
                                <div><span style={{ color: "#5a5a5a" }}>Payment Method: </span>{record.method ? record.method : "UPI"}</div>
                                <div><span style={{ color: "#5a5a5a" }}>Currency: </span>{record.currency ? record.currency : "INR"}</div>
                                {record.status && <div><span style={{ color: "#5a5a5a" }}>Status: </span>{record.status}</div>}
                                {sessionStorage.getItem('role') === "admin" && <div><span style={{ color: "#5a5a5a" }}>Payment Portal: </span>{record.portal}</div>}
                                {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                            </div>)}
                            onContextMenu={event => event.preventDefault()}
                            linkType={false}
                            rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                        />
                        :
                        <Datagrid component={ScrollableTable}>
                            <TextField source="id" label="Txn ID" />
                            <TextField source="qrcode_description" label="QR Code" />
                            <FunctionField source='amount' label="Amount" render={record => record && record['amount'] ? `₹ ${record['amount']}` : '-'} />
                            <FunctionField source='method' label="Payment Method" render={record => record.method ? record.method : "UPI"} />
                            <FunctionField source='currency' label="Currency" render={record => record.currency ? record.currency : "INR"} />
                            <TextField source='status' label="Status" />
                            <FunctionField source="created_at" label="Time" render={record => record["created_at"] ? renderTime(record["created_at"]) : '-'} />
                            {sessionStorage.getItem('role') === "admin" && <TextField source='portal' label="Payment Portal" />}
                            <TextField source='parking_name' label="Parking Name" />
                        </Datagrid>
                }
            </List>
        </ResourceContextProvider>
    )};

    const QrCodesList = (props) => (
        <ResourceContextProvider value="qrCodes">
            <List
                {...props}
                basePath="/qrCodes"
                title="QR Codes"
                bulkActionButtons={false}
                exporter={false}
                filter={filter}
                empty={false}
                pagination={<CustomPagination />}
                actions={false}
                sort={{ field: 'collected_amount', order: 'DESC' }}
                syncWithLocation={false}
            >
                {
                    isSmallDevice ?
                        <SimpleList
                            primaryText={record => record.operator_name}
                            secondaryText={record => (<div>
                                {record.id && <div><span style={{ color: "#5a5a5a" }}>ID: </span>{record.id}</div>}
                                {sessionStorage.getItem('role') === "admin" && <div><span style={{ color: "#5a5a5a" }}>Payment Portal: </span>{record.portal}</div>}
                                {record.collected_amount && <div><span style={{ color: "#5a5a5a" }}>Amount: </span>₹ {record.collected_amount - record.refunded_amount}</div>}
                                {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                                <FunctionField source='refunded_amount' label="QR Utilization" render={record => record && <ProgressBar totalAmount={+qrTransactionsSummary.balance_amount}  value ={record['collected_amount']} />} />
                            </div>)}
                            onContextMenu={event => event.preventDefault()}
                            linkType={false}
                            rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                        />
                        :
                        <Datagrid component={ScrollableTable}>
                            <TextField source="id" label="ID" />
                            <TextField source="operator_name" label="Name" />
                            {sessionStorage.getItem('role') === "admin" && <TextField source="portal" label="Payment Portal" />}
                            <FunctionField source='collected_amount' label="Amount" render={record => `₹ ${record['collected_amount'] - record['refunded_amount']}`} />
                            <TextField source="parking_name" label="Parking Name" />
                            <FunctionField source='refunded_amount' label="QR Utilization" render={record => record && <ProgressBar totalAmount={+qrTransactionsSummary.balance_amount}  value ={record['collected_amount']} />} />
                        </Datagrid>
                }
            </List>
        </ResourceContextProvider>
    );

    const QrLeasingList = (props) => {
        return (
        <ResourceContextProvider value="qrTransactions">
            <List
                {...props}
                basePath="/qrTransactions"
                title="QR Transactions"
                bulkActionButtons={false}
                exporter={false}
                filter={QrLeasingFilters}
                empty={false}
                pagination={<CustomPagination />}
                actions={false}
                sort={{ field: 'created_at', order: 'DESC' }}
                syncWithLocation={false}
            >
                {
                    isSmallDevice ?
                        <SimpleList
                            primaryText={record => renderTime(record["created_at"])}
                            secondaryText={record => (<div>
                                {record.id && <div><span style={{ color: "#5a5a5a" }}>Txn ID: </span>{record.id}</div>}
                                {record.description && <div><span style={{ color: "#5a5a5a" }}>QR Code: </span>{record.qrcode_description}</div>}
                                {record.amount && <div><span style={{ color: "#5a5a5a" }}>Amount: </span>₹ {record.amount}</div>}
                                <div><span style={{ color: "#5a5a5a" }}>Payment Method: </span>{record.method ? record.method : "UPI"}</div>
                                <div><span style={{ color: "#5a5a5a" }}>Currency: </span>{record.currency ? record.currency : "INR"}</div>
                                {record.status && <div><span style={{ color: "#5a5a5a" }}>Status: </span>{record.status}</div>}
                                {sessionStorage.getItem('role') === "admin" && <div><span style={{ color: "#5a5a5a" }}>Payment Portal: </span>{record.portal}</div>}
                                {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                            </div>)}
                            onContextMenu={event => event.preventDefault()}
                            linkType={false}
                            rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                        />
                        :
                        <Datagrid component={ScrollableTable}>
                            <TextField source="id" label="Txn ID" />
                            <TextField source="qrcode_description" label="QR Code" />
                            <FunctionField source='amount' label="Amount" render={record => record && record['amount'] ? `₹ ${record['amount']}` : '-'} />
                            <FunctionField source='method' label="Payment Method" render={record => record.method ? record.method : "UPI"} />
                            <FunctionField source='currency' label="Currency" render={record => record.currency ? record.currency : "INR"} />
                            <TextField source='status' label="Status" />
                            <FunctionField source="created_at" label="Time" render={record => record["created_at"] ? renderTime(record["created_at"]) : '-'} />
                            {sessionStorage.getItem('role') === "admin" && <TextField source='portal' label="Payment Portal" />}
                            <TextField source='parking_name' label="Parking Name" />
                        </Datagrid>
                }
            </List>
        </ResourceContextProvider>
    )};

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        const result = finalZones.find((val) => val.id === event.target.value);
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: result && result.name ? result.name : undefined,
            allZones: event.target.value === "All"
        });
    };

    const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};

    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };

    const fetchqrTransactionsSummary = () => {
		setLoadingSummary(true);

        let params = {
            start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "",
            end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            access_key_id: currentParking.id ? currentParking.id : undefined,
            parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
            access_key: currentParking.access_key ? currentParking.access_key : undefined,
            portal: undefined,
            qrcode: undefined,
        };
    
        if (currentTab === QR_TRANSACTIONS) {
            params.portal = settingFilterFormatTransactions && settingFilterFormatTransactions.portal ? settingFilterFormatTransactions.portal : undefined;
            params.qrcode = settingFilterFormatTransactions && settingFilterFormatTransactions.qrcode ? settingFilterFormatTransactions.qrcode : undefined;
        } else if (currentTab === QR_CODES) {
            params.portal = settingFilterFormatCodes && settingFilterFormatCodes.portal ? settingFilterFormatCodes.portal : undefined;
            params.qrcode = settingFilterFormatCodes && settingFilterFormatCodes.qrcode ? settingFilterFormatCodes.qrcode : undefined;
        } else if (currentTab === QR_LEASING) {
            params.is_leasing = 1;
            params.portal = settingFilterFormatLeasing && settingFilterFormatLeasing.portal ? settingFilterFormatLeasing.portal : undefined;
            params.qrcode = settingFilterFormatLeasing && settingFilterFormatLeasing.qrcode ? settingFilterFormatLeasing.qrcode : undefined;
        }

        fetch(`${config.HOST_NAME}/crm/v3/qrTransactionsSummary?${stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
        })
            .then(response => {
                saveTokens(response);
                return response.json();
            })
            .then(json => {
                if (json.success) setqrTransactionSummary(json.data);
                else notify(json.message, "warning");
            })
            .catch((e) => {
                console.log(e);
                notify("Something went wrong", "warning");
            })
            .finally(() => {
                setLoadingSummary(false);
            });
    };

    useEffect(() => {
        eventTracker(CATEGORY, "QR TRANSACTIONS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        fetchqrTransactionsSummary()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDateTimeFilter, endDateTimeFilter, currentParking, settingFilterFormatTransactions, settingFilterFormatCodes, settingFilterFormatLeasing, currentTab])

    useEffect(() => {
        // QR Transaction Filters
        let values = {}
        if (filterListValueTransactions) {
            for (let val in filterListValueTransactions) {
                if (filterListValueTransactions[val].filterType === "Portal") {
                    values = { ...values, portal: filterListValueTransactions[val].value ? filterListValueTransactions[val].value : undefined }
                }
                else if (filterListValueTransactions[val].filterType === "QR Codes") {
                    values = { ...values, qrcode: filterListValueTransactions[val].value ? filterListValueTransactions[val].value : undefined }
                }
            }
            setSettingFilterFormatTransactions(values)
        }
        if (filterListValueTransactions === null) {
            setSettingFilterFormatTransactions({})
        }
    }, [filterListValueTransactions])

    useEffect(() => {
        // QR Codes
        let values = {}
        if (filterListValueCodes) {
            for (let val in filterListValueCodes) {
                if (filterListValueCodes[val].filterType === "Portal") {
                    values = { ...values, portal: filterListValueCodes[val].value ? filterListValueCodes[val].value : undefined }
                }
                else if (filterListValueCodes[val].filterType === "QR Codes") {
                    values = { ...values, qrcode: filterListValueCodes[val].value ? filterListValueCodes[val].value : undefined }
                }
            }
            setSettingFilterFormatCodes(values)
        }
        if (setFilterListValueCodes === null) {
            setSettingFilterFormatCodes({})
        }
    }, [filterListValueCodes])

    useEffect(() => {
        // QR Leasing
        let values = {}
        if (filterListValueLeasing) {
            for (let val in filterListValueLeasing) {
                if (filterListValueLeasing[val].filterType === "Portal") {
                    values = { ...values, portal: filterListValueLeasing[val].value ? filterListValueLeasing[val].value : undefined }
                }
                else if (filterListValueLeasing[val].filterType === "QR Codes") {
                    values = { ...values, qrcode: filterListValueLeasing[val].value ? filterListValueLeasing[val].value : undefined }
                }
            }
            setSettingFilterFormatLeasing(values)
        }
        if (filterListValueLeasing === null) {
            setSettingFilterFormatLeasing({})
        }
    }, [filterListValueLeasing])


    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter && <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />}

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            {currentTab === QR_CODES && <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />}
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} />
            {currentTab === QR_TRANSACTIONS && <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValueTransactions} setFilterListValue={setFilterListValueTransactions} pathName={location.pathname} />}
            {currentTab === QR_CODES && <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValueCodes} setFilterListValue={setFilterListValueCodes} pathName={location.pathname} />}
            {currentTab === QR_LEASING && <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValueLeasing} setFilterListValue={setFilterListValueLeasing} pathName={location.pathname} />}
        </div>
        <ShowTimePeriod startDateTimeFilter={startDateTimeFilter} endDateTimeFilter={endDateTimeFilter} showTiles={showTiles} setShowTiles={setShowTiles} />

        {showTiles &&
            <div className="vehicleSummaryContainer" style={{ marginTop: 15 }}>
                <TransactionSummaryCard
                    title="Collected Amount"
                    value={+qrTransactionsSummary.total_transactions_amount}
                    valueFormatter={value => `₹ ${value.toFixed(2)}`}
                    count={qrTransactionsSummary.total_transactions_count}
                    loading={loadingSummary}
                />
                <TransactionSummaryCard
                    title="Refunded Amount"
                    value={+qrTransactionsSummary.refunded_transactions_amount}
                    valueFormatter={value => `₹ ${value.toFixed(2)}`}
                    count={qrTransactionsSummary.refunded_transactions_count}
                    loading={loadingSummary}
                />
                <TransactionSummaryCard
                    title="Balance"
                    value={+qrTransactionsSummary.balance_amount}
                    valueFormatter={value => `₹ ${value.toFixed(2)}`}
                    count={qrTransactionsSummary.captured_transactions_count}
                    loading={loadingSummary}
                />
                {/* <DistributionSummaryCard
                transactions={qrTransactionsSummary.transaction_distribution}
                totalTransactionsAmount={+qrTransactionsSummary.balance_amount}
                loading={loadingSummary}
            /> */}
                {/* <DevicesUnderParking devices={devices} totalDevicesAmount={totalDevicesAmount} serialNumberToFilter={serialNumberToFilter} setSerialNumberToFilter={setSerialNumberToFilter} loading={deviceLoader} /> */}
            </div>
        }

        <div style={{ display: "flex", alignItems: "center", columnGap: 10, marginTop: 20, fontSize: 14, boxShadow : '0px 4px 15px rgba(0, 0, 0, 0.1)'}}>
            <div onClick={() => setCurrentTab(QR_TRANSACTIONS)} style={{ borderBottom: currentTab === QR_TRANSACTIONS ? "solid 2px #334d6e" : "#FFF", color: currentTab === QR_TRANSACTIONS ? "#334d6e" : "#999", padding: "12px 25px", cursor:'pointer', fontWeight: currentTab === QR_TRANSACTIONS ?  'bold' : 'normal' }}>
                QR Transactions
            </div>
            <div onClick={() => setCurrentTab(QR_CODES)} style={{ borderBottom: currentTab === QR_CODES ? "solid 2px #334d6e" : "#FFF", color: currentTab === QR_CODES ? "#334d6e" : "#999", padding: "12px 25px", cursor:'pointer', fontWeight: currentTab === QR_CODES ?  'bold' : 'normal' }}>
                QR Codes
            </div>
            {<div onClick={() => setCurrentTab(QR_LEASING)} style={{ borderBottom: currentTab === QR_LEASING ? "solid 2px #334d6e" : "#FFF", color: currentTab === QR_LEASING ? "#334d6e" : "#999", padding: "12px 25px", cursor:'pointer', fontWeight: currentTab === QR_LEASING ?  'bold' : 'normal' }}>
                QR Leasing
        </div>}
        </div>

        {currentTab === QR_TRANSACTIONS && <QrTransactionList/>}
        {currentTab === QR_CODES && <QrCodesList/>}
        {currentTab === QR_LEASING && <QrLeasingList/>}

        {/* <List
            {...props}
            style={{marginTop: 30}}
            title="QR Transactions"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            pagination={<CustomPagination />}
            actions={false}
            sort={{ field: 'created_at', order: 'DESC' }}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        primaryText={record => renderTime(record["created_at"])}
                        secondaryText={record => (<div>
                            {record.description && <div><span style={{ color: "#5a5a5a" }}>Description: </span>{record.qrcode_description}</div>}
                            {record.amount && <div><span style={{ color: "#5a5a5a" }}>Amount: </span>₹ {record.amount}</div>}
                            {record.method && <div><span style={{ color: "#5a5a5a" }}>Payment Method: </span>{record.method}</div>}
                            {record.currency && <div><span style={{ color: "#5a5a5a" }}>Currency: </span>{record.currency}</div>}
                            {record.status && <div><span style={{ color: "#5a5a5a" }}>Status: </span>{record.status}</div>}
                            {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking: </span>{record.parking_name}</div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                :
                    <Datagrid component={ScrollableTable}>
                        <TextField source="qrcode_description" label="Description" />
                        <FunctionField source='amount' label="Amount" render={record => record && record['amount'] ? `₹ ${record['amount']}` : '-'} />
                        <TextField source='method' label="Payment Method" />
                        <TextField source='currency' label="Currency" />
                        <TextField source='status' label="Status" />
                        <FunctionField source="created_at" label="Time" render={record => record["created_at"] ? renderTime(record["created_at"]) : '-'} />
                        <TextField source='parking_name' label="Parking" />
                    </Datagrid>
            }
        </List> */}
    </div>
};

function TransactionSummaryCard({ title, value, valueFormatter = value => value, count, loading }) {
    const classes = useStyles();
    return <>
        <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
            <div style={{ flex: 1 }}>
                <div>
                    <Typography className={classes.title}>{title}</Typography>
                    {
                        !loading ?
                            <div style={{ display: "flex" }}>
                                <Typography className={classes.mainValue}>{valueFormatter(value)}</Typography>
                            </div>
                            :
                            <Skeleton variant="text" height={36} width="34%" />
                    }
                </div>

                <div style={{ marginTop: 25 }}>
                    <Typography className={classes.summaryBoxLabel2}>Transactions</Typography>
                    {!loading ? <Typography className={classes.summaryBoxValue2}>{count}</Typography> : <Skeleton variant="text" height={36} width="34%" />}
                </div>
            </div>
        </Paper>
    </> 
}

// const DistributionSummaryCard = ({ transactions, totalTransactionsAmount, loading }) => {
// 	const classes = useStyles();
// 	const donutColors = ['#FC7668', '#3EF791', '#FFCBA5', '#FFA7A6', '#92EEFC', '#5E8DD3', '#FFA726']
// 	const [selectedQr, setSelectedQr] = useState(null)

//     useEffect(() =>{
//         setSelectedQr(null)
//     },[loading])
	
// 	return <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>

//         <div style={{ flex: 2 }}>
//             <div>
//                 <Typography className={classes.summaryBoxLabel2}>Balance by QR's</Typography>
//                 {!loading ? <Typography className={classes.summaryBoxValue2}>₹ {selectedQr ? selectedQr.amount : totalTransactionsAmount ? totalTransactionsAmount : '0.00'}</Typography>
//                     : <Skeleton variant="text" height={36} width="34%" />}
//             </div>

//             <div style={{ marginTop: 25 }}>
//                 <Typography className={classes.title}>QR's</Typography>
//                 {!loading ? <Typography className={classes.mainValue}>{selectedQr ? selectedQr.qr_code_id : transactions && transactions[0] ? transactions.length : 0}</Typography>
//                     :
//                     <Skeleton variant="text" height={36} width="34%" />}
//             </div>
//         </div>
// 		<div>
// 			{!loading && <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', flex: 1, width: '150px' }}>
// 				<ReactApexChart
// 					series={transactions && transactions[0] ? [...transactions.filter((val) => val.amount > 0).map((val) => val.amount)] : [1]}
// 					type="donut"
// 					height='120'
// 					widht='120'
// 					options={{
// 						dataLabels: {
// 							enabled: false
// 						},
// 						colors: transactions && transactions[0] ? [...donutColors] : ['#F4F4F4'],
// 						chart: {
// 							type: 'donut',
// 							fontFamily: "Poppins-Regular",
// 							events: {
// 								dataPointSelection: (event, chartContext, config) => {
// 									let filteredQrs = transactions.filter((val) => val.amount > 0).map((val) => val)
//                                     console.log(filteredQrs)
// 									setSelectedQr((prev) => {
// 										if (prev && filteredQrs[config.dataPointIndex].description === prev.description) {
// 											return null
// 										} else return filteredQrs[config.dataPointIndex]
// 									})
// 								}
// 							}
// 						},
// 						legend: {
// 							show: false
// 						},
// 						tooltip: {
// 							enabled: true,
// 							style: {
// 								fontSize: '12px',
// 								fontFamily: "Poppins-Regular"
// 							},
// 							marker: {
// 								show: true,
// 							},
// 							custom: function ({ series, seriesIndex, dataPointIndex, w }) {
// 								// let selected = series[seriesIndex]
// 								let qrName = transactions && transactions[seriesIndex].description ? transactions[seriesIndex].description : ''
// 								return transactions && transactions[0] ? `${qrName} | Amount : ₹ ${transactions[seriesIndex].amount}` : ''
// 							}
// 						}
// 					}}
// 				/>
// 				{transactions && transactions[0] ? <div style={{ display: 'flex', flexWrap: 'wrap', fontSize: 10, lineHeight: '1px', color: '#9e9e9e' }}>
// 					{transactions.filter((val) => val.amount > 0).map((val, i) => (
// 						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 10 }}>
// 							<div style={{ backgroundColor: donutColors[i], width: 6, height: 6, borderRadius: 100, marginRight: 5 }}></div>
// 							<p>{val.description.substring(val.description.lastIndexOf(' ', val.description.lastIndexOf(' ') - 1) + 1)}</p>
// 						</div>
// 					))}
// 				</div>
// 					:
// 					<p style={{ fontSize: 10, color: '#9e9e9e' }}>Data not available.</p>}
// 			</div>}
// 		</div>
// 	</Paper>
// }

const ProgressBar = ({ totalAmount, value }) => {
    const calculateProgress = () => {
        if (totalAmount === 0) return 0
        return (value / totalAmount) * 100;
    };

    return (
        <div style={{ width: "100%"}}>
            <p style={{fontSize: 12 ,lineHeight: '1px', color: customTheme.palette.secondary.main, textAlign: 'center'}}>{calculateProgress().toFixed(1)}%</p>
            <LinearProgress
                variant="determinate"
                value={calculateProgress()}
                color='secondary'
            />
        </div>
    );
  };
  